
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize pa-3 font-weight-bold">
            {{ $tc('employees.edit')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="employeeForm" class="px-3">
            <div class="black--text">
              {{ $t('employees.main_data_form_label') }}
            </div>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="12" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.full_name_form_label')"
                  v-model="one_employee.name"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.cpf_form_label')"
                  v-model="one_employee.cpf"
                  :rules="cpf"
                  v-mask='"###.###.###-##"'
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.cau_form_label')"
                  v-model="one_employee.cau"
                  :rules="required"
                ></v-text-field>
              </v-col>
              
            </v-row>

            <v-row align='center' class="mt-3">
              <v-col class="py-0" cols="12" sm="6" md="4" v-if="one_employee.document_kind == 'cpf'">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.rg_form_label')"
                  v-model="one_employee.rg"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.phone_form_label')"
                  v-model="one_employee.phone"
                  :rules="required"
                  v-mask='((one_employee.phone && one_employee.phone.length) < 15) ? "(##) ####-####" : "(##) # ####-####"'
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.email_form_label')"
                  v-model="one_employee.email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.rg_form_label')"
                  v-model="one_employee.rg"
                  :rules="required"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.occupation_form_label')"
                  v-model="one_employee.occupation"
                  :rules="required"
                ></v-text-field>
              </v-col>

              
              <v-col class="py-0" cols="12" sm="6" md="4" v-if="false">
                <vc-date-picker v-model="one_employee.birthdate">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.birthdate_form_label')"
                      :value="one_employee.birthdate && $dayjs(one_employee.birthdate).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="4" v-if="false">
                <vc-date-picker v-model="one_employee.hired_date">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$t('employees.hired_date_form_label')"
                      :value="one_employee.hired_date && $dayjs(one_employee.hired_date).format('DD/MM/YYYY') || ''"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              
            </v-row>

            <div class="black--text my-3" v-if="false">
              {{ $t('employees.address_form_label') }}
            </div>

            <address-form v-if="false" ref="address_form" :validate_form="true" :address="one_employee.address"></address-form>

            <div class="black--text my-3" v-if="false">
              {{ $t('employees.bank_account_form_label') }}
            </div>


            <v-row align='center' class="mt-3" v-if="false">
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.bank_form_label')"
                  v-model="one_employee.bank"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.agency_form_label')"
                  v-model="one_employee.agency"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.account_form_label')"
                  v-model="one_employee.account"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6" md="3">
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$t('employees.pix_form_label')"
                  v-model="one_employee.pix"
                ></v-text-field>
              </v-col>
              
            </v-row>


            <div class="black--text my-3">
              {{ $t('employees.permission_form_label') }}
            </div>

            <v-row align='center' class="mt-3">
              <v-col v-if="false" class="py-0" cols="12" sm="6" md="4">
                <v-select rounded outlined dense class="rounder" 
                  :label="$t('employees.role_form_label')"
                  v-model="one_employee.role_ids"
                  :rules="required"
                  :items="roles"
                  item-text="translated"
                  item-value="id"
                ></v-select>
              </v-col>

              <v-col class="py-0" cols="12" sm="6" md="4">
                <v-select rounded outlined dense class="rounder" 
                  :label="$t('user_roles_label')"
                  v-model="one_employee.role_ids"
                  :rules="required"
                  :items="user_roles"
                  item-text="translated"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </template>


        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancelEmployee" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="saveEmployee" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>

    <dialog-loading v-if="loading" loadingText="saving" ></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import AddressForm from '../../../shared/forms/AddressForm.vue';

export default {
  name: 'DialogEditUserEmployee',
  mixins: [ validations ],
  components: {
    AddressForm
    //ComponentName: () => import(''),
  },
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: true,

      loading: false,
      
      one_employee: {
        name: null,
        cpf: null,
        status: 'active',
        // json_attributes
        phone: null,
        rg: null,
        email: null,
        bank: null,
        agency: null,
        account: null,
        pix: null,
        occupation: null,
        birthdate: null,
        hired_date: null,
        fired_date: null,

        address: {
          street: null,
          number: null,
          district: null,
          city: null,
          state: null,
          zip: null,
          complement: null,
        },

        company_id: null,
        role_ids: [],
      },

      loading_roles: false,
      roles: [],
      user_roles: [],
      occupations: []
    }
  },
  methods: {
    cancelEmployee(){
      this.dialog=false
    },
    setupUserEmployee(){
      this.one_employee = {
        ...this.one_employee,
        ...this.user.json_attributes,
        ...this.user,
        role_ids: this.user.role_ids[0]
      }
    },
    saveEmployee(){
      if (this.$refs.employeeForm.validate()){
        this.loading = true
        let emp = this.prepareEmployee()
        Api.Employee.update(emp).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    prepareEmployee(){
      let {status, emp_id, company_id, role_ids, user_role_ids, ...user} = this.one_employee

      let user_attributes = {
        ...user,
        id: user_id,
        // password: '1029#azo$app',
        // password_confirmation: '1029#azo$app',
        role_ids: [role_ids].flat(),
      }
      
      let obj = {
        user_attributes,
        status, 
        // role_ids: [role_ids].flat(), 
        company_id: this.$route.params.id, 
        id: emp_id
      }
      return obj 
    },
    getRoles(){
      this.loading_roles = true
      Api.Role.index().then(r=> {
        this.roles = [...r.data.map(d=> {
          let translated = this.$t(`employees.roles.${d.name}`)
          return {...d, translated}
        })]
        this.occupations = [...this.roles]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading_roles = false
      })
    },
    getUserRoles(){
      this.loading_roles = true
      Api.Role.index_user_roles().then(r=> {
        this.user_roles = [...r.data.map(d=> {
          let translated = this.$t(`user_roles.${d.name}`)
          return {...d, translated}
        })]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading_roles = false
      })
    },
    
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      profile: (state) => state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.setupUserEmployee()
    this.getRoles();
    this.getUserRoles();
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
  
      } else if (nv == false){
        // this.$router.go(-1)
        this.$emit('close')
      }
    }
  },
}
</script>

<style scoped>

</style>